import {ResearchLitElement, html, css} from '@core/research-lit-element';
import '@bog-design-system/bd-icon';

class researchHamburgerMenu extends ResearchLitElement {
    static get is() {
        return 'research-hamburger-menu';
    }

    static get styles() {
        return css`
            :host {
                position: fixed;
                display: block;
                width: 100%;
                height: 100%;
                z-index: 1000;
                background: var(--color-invert-background-solid-10);
                transition: 1s;
                right: -768px;
                border-top: 1px solid var(--color-invert-component-tr-70);
            }

            .hamburger-menu-items {
                display: flex;
                flex-direction: column;
                padding-left: var(--space-24);
            }

            .hamburger-menu-item {
                height: var(--space-48);
                border-bottom: 1px solid var(--color-invert-component-tr-70);
                align-items: center;
                display: flex;
            }

              .hamburger-menu-items a {
                text-decoration: none;
              }

              .menu-item {
                color: var(--color-invert-component-tr-20);
              }

              .active {
                color: #FF600A;
              }

            .hamburger-active {
                right: 0;
                transition: 0.4s;
            }

          @media (max-width: 600px) {
            .hamburger-menu-items {
              padding-top: var(--space-4);
            }
          }
        `;
    }

    render() {
        return html`
            <div class="wrapper">
                <div class="hamburger-menu-items">
                    ${this.menuItemsData?.length ? this.menuItemsData.map((item) => html`
                            <a  href="${item?.url?.link}"
                                            target="${item?.url?.target}"
                                            class="${this.active.includes(item?.url?.link) ? 'active' : 'menu-item'}"
                                            @click=${this._onMenuItemClick}>
                                            <div class="hamburger-menu-item">
                                                ${item?.label}
                                            </div>
                                        </a>
                            </bd-font>
                        `) : null}
                </div>
            </div>
        `;
    }

    static get properties() {
        return {
            menuItemsData: {
                type: Array,
            },
            active: {
                type: String,
                reflect: true,
            },
        };
    }

    constructor() {
        super();
        this.menuItemsData = [];
        this.active = '';
    }

    _onMenuItemClick() {
        this.classList.toggle('hamburger-active');
        this.dispatchEvent(new CustomEvent('close-hamburger-menu', {
            bubbles: true,
            composed: true,
        }));
    }
}

window.customElements.define(researchHamburgerMenu.is, researchHamburgerMenu);
